export class StammdatenRouteDefs {
  public static FEATURE_PATH = "stammdaten";
}
